declare namespace $ {

	type $mol_paragraph__title_giper_balls_catalog_1 = $mol_type_enforce<
		ReturnType< $giper_balls_catalog['menu_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_giper_balls_catalog_2 = $mol_type_enforce<
		ReturnType< $giper_balls_catalog['lives_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_giper_balls_catalog_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link_support__uri_giper_balls_catalog_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_support['uri'] >
	>
	type $giper_balls_lines__tools_giper_balls_catalog_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_lines['tools'] >
	>
	type $giper_balls_crowd__tools_giper_balls_catalog_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_crowd['tools'] >
	>
	type $giper_balls_chess_game__tools_giper_balls_catalog_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_chess_game['tools'] >
	>
	type $giper_balls_requisites__tools_giper_balls_catalog_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_requisites['tools'] >
	>
	type $giper_balls_offer__tools_giper_balls_catalog_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_offer['tools'] >
	>
	type $giper_balls_shop__tools_giper_balls_catalog_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_balls_shop['tools'] >
	>
	type $mol_view__sub_giper_balls_catalog_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $giper_balls_catalog extends $mol_book2_catalog {
		Title_text( ): $mol_paragraph
		Lives_icon( ): $mol_icon_heart
		lives_text( ): string
		Lives_count( ): $mol_paragraph
		Lives_counter( ): $mol_view
		lives_regen( ): any
		Theme( ): $mol_theme_auto
		Support( ): $mol_link_support
		Lights( ): $mol_lights_toggle
		Lines( ): $giper_balls_lines
		Crowd( ): $giper_balls_crowd
		Chess( ): $giper_balls_chess_game
		Requisites( ): $giper_balls_requisites
		Offer( ): $giper_balls_offer
		Shop( ): $giper_balls_shop
		menu_title( ): string
		Menu_title( ): $mol_view
		auto( ): readonly(any)[]
		plugins( ): readonly(any)[]
		placeholders( ): readonly(any)[]
		menu_foot( ): readonly(any)[]
		spreads( ): ({ 
			'lines': ReturnType< $giper_balls_catalog['Lines'] >,
			'crowd': ReturnType< $giper_balls_catalog['Crowd'] >,
			'chess': ReturnType< $giper_balls_catalog['Chess'] >,
			'requisites': ReturnType< $giper_balls_catalog['Requisites'] >,
			'offer': ReturnType< $giper_balls_catalog['Offer'] >,
			'shop': ReturnType< $giper_balls_catalog['Shop'] >,
		}) 
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map